import { Injectable } from '@angular/core';

import { BetslipType } from '../../../core/betslip-type';
import { flattenPicks } from '../../../core/utils';
import { getPickEachWayInfo, isStartingPriceSelected, isXCastPick } from '../../picks/services/betslip-pick-helpers';
import { isBetStationFreebetToken } from '../../reward-tokens/services/betstation-reward-tokens.utils';
import { isFreebetToken } from '../../reward-tokens/services/reward-tokens.utils';
import { ISingleBetPickState } from '../../single-bet/state';
import { hasCriticalBetslipAndTypeErrorForType, hasCriticalErrorForSlip } from '../../validation/services/utils/betslip-errors-utils';
import { ICalculatorBetslipInput } from '../models';
import { SingleSlipType } from '../slip-type';
import BaseInputBuilder, { BetslipStateInput, InputBuilderGeneratorOptions } from './base-input-builder';
import { getSingleSlipId } from './slip.utils';

// Returns all picks from SingleBet state that are selected and are present in pickList
const defaultSinglePicksSelector = (betslipState: BetslipStateInput) =>
    Object.entries(betslipState.types.singleBet.picks).filter(
        ([key, value]) => value.isSelected && betslipState.picks.pickList.some((p) => p.id.toString() === key),
    );

@Injectable()
export default class SingleBetInputBuilder extends BaseInputBuilder {
    *getBetGeneratorInput(
        rawBetslipState: BetslipStateInput,
        options?: InputBuilderGeneratorOptions<ISingleBetPickState>,
    ): Iterable<ICalculatorBetslipInput> {
        const picksSelector = options?.picksSelector ?? defaultSinglePicksSelector;
        const betslipState = { ...rawBetslipState, picks: { ...rawBetslipState.picks, pickList: flattenPicks(rawBetslipState.picks.pickList) } };

        const singleBetPickIds = picksSelector(betslipState).map(([key, _]) => key);

        for (const pickId of singleBetPickIds) {
            const singleBetPick = betslipState.types.singleBet.picks[pickId];
            const rewardTokenId = singleBetPick.rewardTokenId;

            const pick = betslipState.picks.pickList.find((p) => p.id.isEqual(pickId))!;
            if (!pick) {
                continue;
            }

            const rewardToken = this.getSelectedTokenIfEligible(rewardTokenId, betslipState.rewardTokens, betslipState.types, {
                betslipType: BetslipType.Single,
                pickId: pick.id,
            });

            const stake = isBetStationFreebetToken(rewardToken) || isFreebetToken(rewardToken) ? rewardToken.amount : singleBetPick.stake;

            yield {
                slipId: getSingleSlipId(pick.id),
                items: [
                    {
                        ...this.getPickInfo(pick),
                        eachWayInfo: singleBetPick.isEachWay ? getPickEachWayInfo(pick) : null,
                        isBanker: false,
                        isXCast: isXCastPick(pick),
                        isStartingPrice: isStartingPriceSelected(pick),
                    },
                ],
                rewardToken,
                stake,
                system: new SingleSlipType(),
                hasError:
                    hasCriticalBetslipAndTypeErrorForType(betslipState.errors, BetslipType.Single) ||
                    hasCriticalErrorForSlip(betslipState.errors, getSingleSlipId(pick.id)),
            };
        }
    }
}
